var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.delta)?_c('span',[(_vm.value > 0)?_c('span',{staticClass:"arrow positive"},[_vm._v("▲ ")]):(_vm.value < 0)?_c('span',{staticClass:"arrow negative"},[_vm._v("▼ ")]):_c('span',{staticClass:"zero"},[_vm._v("-")])]):_vm._e(),(!(_vm.delta && Math.abs(_vm.value) <= 0))?_c('span',{style:({ color: _vm.textColorStyle })},[_c('span',{class:{
        zero: !_vm.value || _vm.value == 0,
        not_delta: !_vm.delta,
        positive: _vm.value > 0,
        negative: _vm.value < 0,
      }},[_vm._v(_vm._s(_vm.total.toLocaleString().trim())+"%"),(!_vm.delta && !_vm.emptyVal)?_c('span',[_vm._v("%")]):_vm._e()])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }